import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ISearchAndReplaceSettings } from "../../entities/search-and-replace-settings";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { ModelNotifier } from "../../scripts/model-notifier";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { MessageBox }from "uiv";


@Component
export default class SearchAndReplaceDialog extends Vue {

    @Prop()
    value: ISearchAndReplaceSettings;

    private modelServices = new modelServices(new ModelNotifier());
    private userNotifier = new ClientNotifier();

    okButtonClick() {

        var notification = this.userNotifier.showBusyNotification("Validating search and replace..");


        this.modelServices.searchAndReplaceQuery(
            this.value.modelId,
            this.value.rootNode,
            this.value.searchText,
            this.value.replaceText,
            this.value.targetType)
            .then(data => {

                // Clear out notification
                this.userNotifier.clear(notification);

                // Detect if validated by looking for "Invalid"
                // Crappy but works for now
                var okSearch = data[0].indexOf("Invalid") === -1;

                if (data.length > 10) {
                    const removedCount = data.length - 10;
                    data = data.slice(0, 10);
                    data.push(`+ ${removedCount.toString()} changes`);
                }

                // Put line breaks in response
                var joined = data.join("<br>");

                if (okSearch) {
                    
                    MessageBox.confirm({ title: "Confirm search and replace", content: joined, html: true, size:"lg" })
                        .then(() => {
                                // Go ahead and execute
                                var execNotification =
                                    this.userNotifier.showBusyNotification("Executing search and replace..");
 
                                this.modelServices.executeSearchAndReplace(
                                        this.value.modelId,
                                        this.value.rootNode,
                                        this.value.searchText,
                                        this.value.replaceText,
                                        this.value.targetType)
                                    .then(execData => {
                                            
                                        this.userNotifier.clear(execNotification);

                                        if (execData.success)
                                        this.$emit("dialogClosed", "ok");
                                    }
                                    );
                            

                        });
                } else {

                    MessageBox.alert({
                        title: "Search and replace summary", content: joined, html: true});
                }
            }); }

    areSettingsValid() {
        return true;
    }

    cancelButtonClick() {
        this.$emit("dialogClosed", "cancel");
    }


}



// WEBPACK FOOTER //
// ./ClientApp/components/search-and-replace-dialog/search-and-replace-dialog.ts